// Constants
import { TYPES } from '../types/types.constants';
import { initialStateAuth } from './initial.state';

export const authReducer = (state = initialStateAuth, action) => {

    switch (action.type) {
        case TYPES.AUTH.LOGIN:
            return {

                ...action.payload
            }
        case TYPES.AUTH.LOGOUT:
            return {

                ...initialStateAuth
            }
        case TYPES.AUTH.SET_EMAIL:
            return {
                ...state,
                ...action.payload
            }
        case TYPES.AUTH.SET_ISAUTHENTICATED:
            return {
                ...state,
                user: {
                    ...state.user,
                    isAuthenticated: action.payload
                }
            }
        case TYPES.AUTH.RESET:
            return {
                ...initialStateAuth
            }

        default:
            return state;
    }
};